// ------ Menu ------

//Detect tabbing
function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');

    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove('user-is-tabbing');

  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);

//Main Menu wrapper
$('#menu-main-menu').wrap( "<nav></nav>" );
$('#sticky-sidebar-btm .m-footer-menu > ul').wrap( "<nav></nav>" );
$('#sticky-sidebar-btm .m-footer-menu nav > ul').attr('role', 'menu');

//Accessibility
$('.a-top-menu > a').attr('role', 'menuitem').attr('href', '#/');
$('.a-top-menu .dropdown > .menu-item > a').attr('ontouchstart', '');

//Adding ability to tab through primary nav
document.addEventListener('keyup', function(e) {
  var pressedKey = e.key;
  if (pressedKey === 'Tab' && document.querySelector('.a-top-menu > a:focus')) {
    document.querySelectorAll('.a-top-menu > a').forEach(function(element) {
      element.classList.remove('focused');
      element.parentElement.classList.remove('is-active-desktop-menu');
    });
    var focusedElement = document.querySelector('.a-top-menu > a:focus');
    if (focusedElement) {
      focusedElement.classList.add('focused');
      focusedElement.parentElement.classList.add('is-active-desktop-menu');
    }
  } else if (e.shiftKey && pressedKey === 'Tab' && document.querySelector('.a-top-menu > a:focus')) {
    document.querySelectorAll('.a-top-menu > a').forEach(function(element) {
      element.classList.remove('focused');
      element.parentElement.classList.remove('is-active-desktop-menu');
    });
    var focusedElement = document.querySelector('.a-top-menu > a:focus');
    if (focusedElement) {
      focusedElement.classList.add('focused');
      focusedElement.parentElement.classList.add('is-active-desktop-menu');
    }
  }

  if (pressedKey === 'Tab' && document.querySelector('form button.js-search-button:focus')) {
    document.querySelectorAll('.a-top-menu > a').forEach(function(element) {
      element.classList.remove('focused');
      element.parentElement.classList.remove('is-active-desktop-menu');
    });
  } else if (e.shiftKey && pressedKey === 'Tab' && document.querySelector('form button.js-search-button:focus')) {
    document.querySelectorAll('.a-top-menu > a').forEach(function(element) {
      element.classList.remove('focused');
      element.parentElement.classList.remove('is-active-desktop-menu');
    });
  }
});

// Hamburger Mobile Menu Toggle
$(".js-mobile-menu-toggle").on("click", function (e) {
  if (!$("body").hasClass("js-mobile-menu-opened")) {
    $("body").addClass("js-mobile-menu-opened");
    $(".js-header").addClass("js-mobile-menu-opened");
    $(".js-header-navigation").slideDown();
  } else {
    $("body").removeClass("js-mobile-menu-opened");
    $(".js-header").removeClass("js-mobile-menu-opened");
    $(".js-header-navigation").slideUp();
  }
});


// $(function() {
//   $('.m-main-menu  > .a-top-menu > .submenu > .opens-right').attr('data-is-click', 'true').removeAttr('aria-haspopup').attr('role','menuitem').addClass('is-active');
//   $('.m-main-menu  > .a-top-menu > .submenu > .opens-right > .submenu').addClass('js-dropdown-active').addClass('is-active');
// });

document.addEventListener('DOMContentLoaded', function() {
  var menuItems = document.querySelectorAll('.m-main-menu > .a-top-menu');

  menuItems.forEach(function(item) {
    item.addEventListener('click', function(event) {
      event.stopPropagation();
      var isClicked = item.getAttribute('data-is-click') === 'true';

      // Remove attributes and classes from all other elements
      menuItems.forEach(function(otherItem) {
        if (otherItem !== item) {
          otherItem.removeAttribute('data-is-click');
          otherItem.classList.remove('is-active');
        }
      });

      // Toggle attributes and classes on the clicked element
      if (isClicked) {
        item.removeAttribute('data-is-click');
        item.classList.remove('is-active');
      } else {
        item.setAttribute('data-is-click', 'true');
        item.classList.add('is-active');
      }
    });
  });

  // Remove attributes and classes when clicking outside
  document.addEventListener('click', function() {
    menuItems.forEach(function(item) {
      item.removeAttribute('data-is-click');
      item.classList.remove('is-active');
    });
  });
});

document.addEventListener('mouseup', function(e) {
  // Mobile -- Close Menu when click overlay
  var container = document.querySelector('.js-header.js-mobile-menu-opened');
  // if the target of the click isn't the container nor a descendant of the container
  if (
    window.matchMedia('(max-width: 1049px)').matches &&
    container && !container.contains(e.target)
  ) {
    document.body.classList.remove('js-mobile-menu-opened');
    container.classList.remove('js-mobile-menu-opened');
    document.querySelector('.js-header-navigation').style.display = 'none';
  }

  // Desktop -- Click elsewhere of menu & submenu, close all submenu
  if (window.matchMedia('(min-width: 1050px)').matches) {
    var mainParent = document.querySelector('.is-active-desktop-menu');
    if (
      mainParent &&
      !(
        e.target.matches('.m-main-menu') ||
        e.target.matches('.dropdown') ||
        e.target.matches('.dropdown a') ||
        e.target.matches('.menu-item') ||
        e.target.matches('.menu-item a')
      )
    ) {
      closeSubmenus(mainParent);
    }
  }
});

// ****** Resize or window size change ******
let menuResponsiveMode = "desktop";
$(window).on("load", function () {
  // First Load
  if (window.matchMedia("(max-width: 1049px)").matches) {
    menuResponsiveMode = "mobile";
  } else {
    menuResponsiveMode = "desktop";
  }
  desktopMenuToggler();

  $(window).on("resize orientationchange", function () {
    if (window.matchMedia("(max-width: 1049px)").matches) {
      menuResponsiveMode = "mobile";
    } else {
      menuResponsiveMode = "desktop";

      var $container = $(".js-header.js-mobile-menu-opened");
      $("body").removeClass("js-mobile-menu-opened");
      $container.removeClass("js-mobile-menu-opened");
      $(".js-header-navigation").slideUp();
    }
  });
});


// *** Desktop Toggler ***
const mainParent = $(
  ".js-header-navigation .menu-item.menu-item-has-children.a-top-menu"
);

const openSubmenus = (item) => {
  item
    .addClass("is-active-desktop-menu")
    .children(".dropdown.menu")
    .addClass("is-active-desktop-menu");
  item
    .siblings()
    .removeClass("is-active-desktop-menu")
    .children(".dropdown.menu")
    .removeClass("is-active-desktop-menu");
};

const closeSubmenus = (items) => {
  $(items) 
    .removeClass("is-active-desktop-menu")
    .children(".dropdown.menu")
    .removeClass("is-active-desktop-menu");
};

const desktopMenuToggler = () => {
  mainParent.each(function () {
    $(this).on("mouseenter touchstart", function () {
      if (menuResponsiveMode !== "desktop") {
        return;
      }
      openSubmenus($(this));
    });

    $(this).on("click", function (e) {
      if (menuResponsiveMode !== "desktop") {
        return;
      }
      if (
        $(this).hasClass("is-active-desktop-menu") &&
        !(
          $(e.target).is(".m-main-menu") ||
          $(e.target).is(".dropdown") ||
          $(e.target).is(".dropdown a") ||
          $(e.target).is(".menu-item")
        )
      ) {
        closeSubmenus($(this));
      } else if (!$(this).hasClass("is-active-desktop-menu")) {
        openSubmenus($(this));
      }
    });
  });
};
